import {frameworkDesktopSettingPanel} from "../../../core/components/desktopSettingPanel/configuration/desktopSettingPanelConfiguration"
import React from "react";
import {desktopSettingPanelAssetConfig} from "../../../data/desktopSettingPanel";
import {autoplayAssetConfig} from "../../../data/autoplay";


frameworkDesktopSettingPanel.data = {
    "settingIconImage": desktopSettingPanelAssetConfig["settingIconImage"],
    "toggleButtonOnImage": autoplayAssetConfig["toggleButtonOnImage"],
    "toggleButtonOffImage": autoplayAssetConfig["toggleButtonOffImage"],
    "soundIconImage": desktopSettingPanelAssetConfig["soundIconImage"],
    "autoplayIconImage": desktopSettingPanelAssetConfig["autoplayIconImage"],
    "turboIconImage": desktopSettingPanelAssetConfig["turboIconImage"],


    "COMPONENTS": []

}